import AGREGAR_CATALOGO_AUDITORIA_ETIQUETA from '@/graphql/mutations/administracion/auditorias/catalogo-etiquetas/agregarCatalogoAuditoriaEtiqueta.gql';
import ACTUALIZAR_CATALOGO_AUDITORIA_ETIQUETA from '@/graphql/mutations/administracion/auditorias/catalogo-etiquetas/actualizarCatalogoAuditoriaEtiqueta.gql';
import REMOVER_CATALOGO_AUDITORIA_ETIQUETA from '@/graphql/mutations/administracion/auditorias/catalogo-etiquetas/removerCatalogoAuditoriaEtiqueta.gql';
import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';

export default {
  methods: {
    async mixAgregarCatalogoAuditoriaEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_AUDITORIA_ETIQUETA,
        variables: {
          catalogoAuditoriaEtiqueta: this.catalogoAuditoriaEtiqueta,
        },
        update: (store, { data: { agregarCatalogoAuditoriaEtiqueta } }) => {
          const data = store.readQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS });
          data.catalogoAuditoriaEtiquetas.push(agregarCatalogoAuditoriaEtiqueta);
          store.writeQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarCatalogoAuditoriaEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_AUDITORIA_ETIQUETA,
        variables: {
          id: this.catalogoAuditoriaEtiquetaEditar.id,
          catalogoAuditoriaEtiqueta: this.catalogoAuditoriaEtiqueta,
        },
        update: (store, { data: { actualizarCatalogoAuditoriaEtiqueta } }) => {
          const data = store.readQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS });
          const { catalogoAuditoriaEtiquetas } = data;
          const index = catalogoAuditoriaEtiquetas
            .findIndex((catalogoAuditoriaEtiqueta) => catalogoAuditoriaEtiqueta.id
                === actualizarCatalogoAuditoriaEtiqueta.id);
          if (index !== -1) {
            catalogoAuditoriaEtiquetas.splice(index, 1, actualizarCatalogoAuditoriaEtiqueta);
          }
          store.writeQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarCatalogoAuditoriaEtiqueta() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_AUDITORIA_ETIQUETA,
        variables: {
          id: this.catalogoAuditoriaEtiquetaEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS });
          const { catalogoAuditoriaEtiquetas } = data;
          const index = catalogoAuditoriaEtiquetas
            .findIndex((catalogoAuditoriaEtiqueta) => catalogoAuditoriaEtiqueta.id
                === this.catalogoAuditoriaEtiquetaEliminar.id);
          if (index !== -1) {
            catalogoAuditoriaEtiquetas.splice(index, 1);
          }
          store.writeQuery({ query: CATALOGO_AUDITORIA_ETIQUETAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
